function toggleDropdownContent(event) {
  const title = event.currentTarget.closest('.dropdown-title');
  const toggleId = title.getAttribute('data-toggle-id');
  const content = document.getElementById(toggleId);
  const icon = title.querySelector('.dropdown-icon');

  if (content.classList.contains('open')) {
    content.style.maxHeight = '0';
    content.classList.remove('open');
    icon.textContent = '+';
  } else {
    document.querySelectorAll('.dropdown-content').forEach((dropdown) => {
      dropdown.style.maxHeight = '0';
      dropdown.classList.remove('open');
      const otherIcon = dropdown.previousElementSibling.querySelector('.dropdown-icon');
      otherIcon.textContent = '+';
    });

    content.style.maxHeight = content.scrollHeight + 'px';
    content.classList.add('open');
    icon.textContent = '-';
  }
}

if (window.innerWidth <= 768) {
  document.querySelectorAll('.dropdown-title').forEach((title) => {
    title.addEventListener('click', toggleDropdownContent);
    if (title.classList.contains('open')) {
      title.click();
    }
  });
}
